import { Component, inject } from '@angular/core';

import { AnalyticsService } from './shared/analytics/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  // Explicitly inject AnalyticsService to ensure it initializes on app startup
  // This is necessary because ENVIRONMENT_INITIALIZER may not work reliably in production builds
  private analytics = inject(AnalyticsService);

  constructor() {
    // Google Site Verification meta tag is now injected during build process
    // See scripts/inject-env-to-html.js
  }
}
